module.exports = __webpack_public_path__ + "img/align_equal_distribution.560716c7.svg";